(function () {
	const initReviewsSlider = () => {
		$('.product-reviews-onyra-section').each(function () {
			if ($(this).hasClass('slider_started')) return;
			$(this).addClass('slider_started');

			const id = $(this).attr('id');
			const box = $(this).find('.product-reviews-onyra');
			if (box.data('layout') !== 'carousel') return;

			const autoplay = box.data('autoplay');
			const stopAutoplay = box.data('stop-autoplay');
			const delay = box.data('delay') * 1000;
			let autoplayParm = {};

			if (autoplay) {
				autoplayParm = {
					autoplay: {
						delay: delay,
						pauseOnMouseEnter: stopAutoplay,
						disableOnInteraction: false,
					},
				};
			}

			const swiperParms = {
				effect: 'slide',
				speed: box.data('speed') * 1000,
				slidesPerView: 1,
				spaceBetween: 20,
				breakpoints: {
					750: {
						slidesPerView: 2,
						spaceBetween: 20,
					},
					990: {
						slidesPerView: 3,
						spaceBetween: 24,
					},
				},
				autoHeight: false,
				keyboard: true,
				navigation: {
					nextEl: `#${id} .swiper-button-next`,
					prevEl: `#${id} .swiper-button-prev`,
				},
				pagination: {
					el: `#${id} .swiper-pagination`,
					clickable: true,
				},
				...autoplayParm,
			};

			new Swiper(`#${id} .swiper`, swiperParms);
		});
	};

	document.addEventListener('DOMContentLoaded', function () {
		initReviewsSlider();
		document.addEventListener('shopify:section:load', function () {
			initReviewsSlider();
		});
	});
})();
